<template>
  <div class="tour-list__sidebar">
    <div class="c-sidebar w-100">
      <div class="sidebar fa-num" :class="getOpenFilterMobile ? 'open-filter' : ''">
        <div class="sidebar__header">
          <span class="fa-num hide-in-not-desktop"> {{ getFilteredResults.length }} تور پیدا شد</span>

          <span class="hide-in-desktop"> فیلتر کردن </span>

          <button class="hide-in-desktop btn" @click="toggleFilterBoxMobile">
            <i class="icon-close" />
          </button>
        </div>

        <div v-for="filter in getStaticFilters" :key="filter.id">
          <FilterPart :filter="filter" v-if="filter.title" />
        </div>
        <div class="sidebar__footer hide-in-desktop">
          <button class="btn btn--secondary w-100" @click="toggleFilterBoxMobile">
            اعمال فیلتر
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import FilterPart from "./FilterPart.vue";

export default {
  name: "SideBar",

  components: {
    FilterPart,
  },

  computed: {
    ...mapState(["filters"]),
    ...mapGetters(["getOpenFilterMobile", "getStaticFilters", "getFilteredResults"]),
  },

  methods: {
    ...mapActions(["toggleFilterBoxMobile"]),
  },
};
</script>

<style lang="scss">
@import "../style/modules/_sidebar.scss";
</style>
